/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetReportsDealsPipelineQueryResponse,
  GetReportsDealsPipelineQueryParams,
} from '../types/GetReportsDealsPipeline'

function getGetReportsDealsPipelineUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/reports/dashboard/deals-pipeline/` as const,
  }
  return res
}

/**
 * @description One row per contact company (chain proxy), aggregated across that company's deal-report rows. Returns [] when the company has no deal-report rows.
 * @summary Reports dashboard deals pipeline (per-company rows)
 * {@link /api/v1/reports/dashboard/deals-pipeline/}
 */
export async function getReportsDealsPipeline(
  params?: GetReportsDealsPipelineQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetReportsDealsPipelineQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetReportsDealsPipelineUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
